import { QueryEditor } from "./QueryEditor";
import StandardQueryRunner from "./StandardQueryRunner";

const StandardQueryEditorTab = () => (
  <>
    <QueryEditor />
    <StandardQueryRunner />
  </>
);

export default StandardQueryEditorTab;
